import produce from 'immer';
import { combineReducers } from 'redux';

import type { Action } from 'Lib/reduxType';

import { getCommonResetAction } from 'Store/commonActions';
import { FETCH_PROFILE_SUCCESS } from 'Store/profile/constants';

import {
  TOGGLE_ONLY_VERIFIED_USERS_MESSAGE_CONTROL,
  TOGGLE_ONLY_VERIFIED_USERS_MESSAGE_CONTROL_ERROR,
  UPDATE_EMAIL_NOTIFICATION_SETTINGS,
  UPDATE_PUSH_NOTIFICATION_SETTINGS,
} from './constants';
import initialState from './initialState';
import type { SettingsState } from './types';

const emailNotificationsReducer = produce<SettingsState['emailNotifications'], [Action]>(
  (draft, action) => {
    switch (action.type) {
      case FETCH_PROFILE_SUCCESS: {
        const { emailSettings = {} } = action.payload?.result ?? {};
        Object.entries(emailSettings).forEach(([key, val]) => {
          draft[key] = val;
        });
        break;
      }
      case UPDATE_EMAIL_NOTIFICATION_SETTINGS: {
        const { emailNotifications = {} } = action.payload ?? {};
        Object.entries(emailNotifications).forEach(([key, val]) => {
          draft[key] = val;
        });
        break;
      }
      case getCommonResetAction(action.type):
        return initialState.emailNotifications;
      default:
        break;
    }
  },
  initialState.emailNotifications
);

const messageControlsReducer = produce<SettingsState['messageControls'], [Action]>(
  (draft, action) => {
    switch (action.type) {
      case FETCH_PROFILE_SUCCESS: {
        const user = action.payload?.data?.user;
        draft.onlyVerifiedUsersError = false;
        draft.onlyVerifiedUsers = user?.request_verification_enabled ?? false;
        break;
      }
      case TOGGLE_ONLY_VERIFIED_USERS_MESSAGE_CONTROL: {
        const value = action.payload?.value ?? false;
        draft.onlyVerifiedUsersError = false;
        draft.onlyVerifiedUsers = value;
        break;
      }
      case TOGGLE_ONLY_VERIFIED_USERS_MESSAGE_CONTROL_ERROR: {
        draft.onlyVerifiedUsersError = true;
        break;
      }
      case getCommonResetAction(action.type):
        return initialState.messageControls;
      default:
        break;
    }
  },
  initialState.messageControls
);

const pushNotificationsReducer = produce<SettingsState['pushNotifications'], [Action]>(
  (draft, action) => {
    switch (action.type) {
      case UPDATE_PUSH_NOTIFICATION_SETTINGS: {
        const { pushNotifications = {} } = action.payload ?? {};
        Object.entries(pushNotifications).forEach(([key, val]) => {
          draft[key] = val;
        });
        break;
      }
      case getCommonResetAction(action.type):
        return initialState.pushNotifications;
      default:
        break;
    }
  },
  initialState.pushNotifications
);

export const reducer = combineReducers({
  emailNotifications: emailNotificationsReducer,
  messageControls: messageControlsReducer,
  pushNotifications: pushNotificationsReducer,
});

export const persistConfig = {
  version: 2,
};
